import { render, staticRenderFns } from "./doorClass.vue?vue&type=template&id=23f5fb82&"
import script from "./doorClass.vue?vue&type=script&lang=js&"
export * from "./doorClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports